import { render, staticRenderFns } from "./ExpertPim.vue?vue&type=template&id=18e1ac42&scoped=true&"
import script from "./ExpertPim.vue?vue&type=script&lang=js&"
export * from "./ExpertPim.vue?vue&type=script&lang=js&"
import style0 from "./ExpertPim.vue?vue&type=style&index=0&id=18e1ac42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e1ac42",
  null
  
)

export default component.exports